import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "@entities/brief/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BriefService } from "../services/brief.service";

export function useUnshortlistInfluencersV2(briefId: string) {
  const {
    mutate: unshortlistInfluencers,
    isLoading: isUnshortlisting,
    isSuccess: isUnshortlisted,
    error: unshortlistError,
  } = useMutation({
    mutationFn: (briefInfluencerId: string) =>
      BriefService.unshortlistInfluencers(briefInfluencerId).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      ),
    options: { skipInvalidation: true },
    onSuccess: (c) => {
      ToastService.success("Creator removed from shortlist");
      setTimeout(() => {
        c.invalidateQueries({
          queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
          exact: false,
        });
        c.invalidateQueries({
          queryKey: [
            ...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
            "facets",
            briefId,
          ],
          exact: false,
        });
      }, 1000);
    },
  });

  return {
    unshortlistInfluencers,
    isUnshortlisting,
    isUnshortlisted,
    unshortlistError,
  };
}
